export default "__VITE_ASSET__Cpt0QY6E__"